import translateNested from "app/pages/sales-intelligence/common-components/i18n/translateNested";
import type { SignalFilterDropdownLabelModel } from "app/pages/sales-intelligence/sub-modules/signals/models/view/SignalFilterDropdownLabelModel";
import type { TranslatableNameWithType } from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterNamingService";
import {
    getSelectionReplacements,
    isPartialFilterName,
} from "app/pages/sales-intelligence/sub-modules/signals/models/services/filterSelectionNaming";
import { removeHTMLTags } from "app/pages/sales-intelligence/sub-modules/signals/utils/removeHTMLTags";
import { tryTranslate } from "app/pages/sales-intelligence/utils/common";

export type BuildSignalFilterDropdownLabelParams = {
    buildName: () => Readonly<TranslatableNameWithType>;
    resolvePrimaryLabel?: () => string;
};

const sanitizeLabel = (value: string): string => removeHTMLTags(value).trim();

const resolveDisplayLabel = (value: string): string => {
    const translated = tryTranslate(value);

    return sanitizeLabel(translated ?? value);
};

export function buildSignalFilterDropdownLabel({
    buildName,
    resolvePrimaryLabel,
}: BuildSignalFilterDropdownLabelParams): SignalFilterDropdownLabelModel {
    const filterName = buildName();
    const replacements = getSelectionReplacements(filterName);
    const remainingOptions = replacements?.remainingOptions ?? 0;

    if (isPartialFilterName(filterName)) {
        const option = replacements?.option ?? "Unknown option";
        const primaryLabel = resolvePrimaryLabel
            ? sanitizeLabel(resolvePrimaryLabel())
            : resolveDisplayLabel(String(option));

        return {
            kind: "partial",
            primaryLabel,
            hiddenCount: remainingOptions,
        };
    }

    if (filterName.type === "singular") {
        return {
            kind: "singular",
            label: sanitizeLabel(translateNested(filterName.translatable)),
        };
    }

    return {
        kind: "plain",
        label: sanitizeLabel(translateNested(filterName.translatable)),
    };
}
